import { render, staticRenderFns } from "./BranchListItem.vue?vue&type=template&id=5f2690f5&scoped=true&"
import script from "./BranchListItem.vue?vue&type=script&lang=js&"
export * from "./BranchListItem.vue?vue&type=script&lang=js&"
import style0 from "./BranchListItem.vue?vue&type=style&index=0&id=5f2690f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2690f5",
  null
  
)

export default component.exports